import { Axis } from '@visx/axis';
import type { D3Scale } from '@visx/scale';
import type { ScaleTime } from 'd3-scale';
import { timeYear } from 'd3-time';
import { useTheme } from '@simplywallst/ui-core';

import { VisxText } from '@/components/VisxText';

export interface Props {
  xScale: ScaleTime<number, number>;
  y: number;
  height: number;
  rotateLabels: boolean;
}

const XAxis = ({ xScale, y, height, rotateLabels }: Props) => {
  const timeYearEvery1 = timeYear.every(1);
  const tickArray =
    timeYearEvery1 !== null ? xScale.ticks(timeYearEvery1) : xScale.ticks(1);
  const theme = useTheme();
  return (
    <>
      <rect
        y={y}
        height="1"
        width="100%"
        fill={theme.color.white}
        fillOpacity={0.2}
      />
      <Axis scale={xScale as D3Scale<number, number>} tickValues={tickArray}>
        {(axis) => {
          return (
            <g>
              <rect
                y={height}
                height="1"
                width="100%"
                fill={theme.color.white}
                fillOpacity={0.2}
              />
              {axis.ticks.map((tick) => (
                <g
                  key={`axis-tick-${tick.to.x}`}
                  transform={`translate(${tick.to.x}, ${height + 1})`}
                >
                  <rect
                    width="1"
                    height="4"
                    fill={theme.color.white}
                    x="0"
                    y="0"
                    fillOpacity={0.2}
                  />
                  <VisxText
                    x="0"
                    y="8"
                    textAnchor="middle"
                    verticalAnchor="start"
                    transform={
                      rotateLabels && tickArray.length >= 12
                        ? 'rotate(-45) translate(-18 -4)'
                        : ''
                    }
                    fill="white"
                    typography="tiny"
                  >
                    {tick.formattedValue}
                  </VisxText>
                </g>
              ))}
            </g>
          );
        }}
      </Axis>
    </>
  );
};

export default XAxis;
